"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styles = require("@material-ui/core/styles");
var _theme = _interopRequireDefault(require("../../theme"));
const useStyles = (0, _styles.makeStyles)({
  rootCardSummary: {
    backgroundColor: _theme.default.palette.white,
    display: 'grid',
    gridTemplateColumns: '30px auto auto auto',
    gridTemplateRows: 'auto auto auto',
    padding: 30,
    borderRadius: 5,
    [_theme.default.breakpoints.down('lg')]: {
      padding: '30px 20px'
    },
    '& img': {
      height: 21,
      marginTop: 8,
      [_theme.default.breakpoints.down('sm')]: {
        padding: 0,
        marginTop: 3
      }
    },
    '& h3': {
      fontSize: _theme.default.typography.pxToRem(24),
      lineHeight: _theme.default.typography.pxToRem(36),
      fontFamily: _theme.default.typography.proxima.semiBold,
      color: _theme.default.palette.primary.main,
      marginBottom: '10px',
      [_theme.default.breakpoints.down('sm')]: {
        fontSize: _theme.default.typography.pxToRem(18),
        lineHeight: '150%'
      }
    },
    '& p': {
      fontFamily: _theme.default.typography.proxima.regular,
      fontSize: _theme.default.typography.pxToRem(16),
      lineHeight: _theme.default.typography.pxToRem(24),
      marginBottom: 0,
      color: _theme.default.palette.grayScale.dark
    },
    '& .confirmation': {
      gridColumnStart: '2',
      '& p': {
        marginBottom: 20
      }
    },
    '& detailsLink': {
      gridColumnStart: '4',
      gridRowStart: '1',
      alignSelf: 'center',
      '& a': {
        fontSize: _theme.default.typography.pxToRem(14),
        lineHeight: '150%',
        margin: '0',
        justifyContent: 'flex-end'
      }
    },
    '& .timeDetails': {
      gridColumn: '2/3',
      '& p': {
        fontWeight: 'bold',
        paddingBottom: 5
      }
    },
    '& .details': {
      gridColumn: '2/5',
      '& p': {
        marginBottom: '0',
        '& span': {
          display: 'block',
          color: _theme.default.palette.grayScale.main
        },
        '& span:last-child': {
          '&::after': {
            content: "' '",
            padding: '0'
          }
        },
        [_theme.default.breakpoints.up('md')]: {
          '& span:nth-child(1n+2)': {
            display: 'inline-block',
            '&::after': {
              content: "'|'",
              padding: '0 16px'
            }
          }
        }
      }
    },
    '& .flightNumber': {
      gridColumn: 4,
      justifySelf: 'flex-end',
      gridRow: 3,
      alignSelf: 'center',
      '& p': {
        fontWeight: 'bold'
      },
      [_theme.default.breakpoints.down('lg')]: {
        gridRow: 4
      }
    },
    '& .passengers': {
      marginTop: '20px',
      gridColumn: '2',
      textTransform: 'capitalize',
      '& span': {
        color: _theme.default.palette.grayScale.main,
        '&:after': {
          content: "', '"
        }
      },
      '& span:first-child': {
        fontWeight: 'bold',
        paddingBottom: '5px',
        color: _theme.default.palette.grayScale.dark,
        display: 'block',
        '&:after': {
          content: "' '"
        }
      },
      '& span:last-child': {
        '&::after': {
          content: "' '"
        }
      },
      [_theme.default.breakpoints.up('xl')]: {
        display: 'none'
      }
    },
    '& .divider': {
      gridColumn: '1/5',
      gridRow: '3',
      marginBottom: '20px',
      borderBottom: "1px solid ".concat(_theme.default.palette.border)
    },
    [_theme.default.breakpoints.up('xl')]: {
      '& .divider': {
        display: 'none'
      }
    },
    [_theme.default.breakpoints.down('sm')]: {
      '& .detailsLink': {
        gridRow: '3',
        gridColumn: '1/3',
        '& a': {
          justifyContent: 'flex-start'
        }
      },
      '& .title': {
        gridColumn: '2/5'
      },
      '& .confirmation': {
        gridColumn: '1/5'
      },
      '& .divider': {
        gridRow: 4
      },
      '& .flightNumber': {
        gridRow: 5
      },
      '& .timeDetails': {
        gridColumn: '1/4'
      },
      '& .details': {
        gridColumn: '1/5'
      },
      '& .passengers': {
        gridColumn: '1/5'
      }
    }
  }
});
var _default = exports.default = useStyles;